export default __webpack_public_path__ + "static/media/sidebar_bg.877b9bdc.png";